/* Console and Activity Admin - Activity Card Description Read More Height  */
export const ACTIVITY_DESC_HEIGHT = 64;
export const ACTIVITY_LINES = 4;

/* Console and Activity Admin - Activity Card Description Read More Height  */
export const ACTIVITY_DESC_HEIGHT_PARTICIPANT = 110;
export const ACTIVITY_LINES_PARTICIPANT = 7;

export const CAROUSEL_SCROLL_OFFSET = 5;
export const CAROUSEL_SCROLL_SPEED_MULTIPLIER = 0.2;

export const READ_MORE_DEFAULT_HEIGHT = 48;

export const TOOLTIP_DEFAULT_OFFSET_X = 0;
export const TOOLTIP_DEFAULT_OFFSET_Y = 8;

export const MENU_POPOVER_TOOLTIP_DIRECTION_UP_OFFSET = 10;

export const TABLE_DEFAULT_OPTIONS_HEIGHT = 34;
export const PAGINATION_TABLE_DEFAULT_OPTIONS_HEIGHT = 58;

export const TEXT_EDITOR_SIZE_LARGE = 350;
export const TEXT_EDITOR_DEFAULT_SIZE = 160;
export const TEXT_EDITOR_SIZE_SINGLE_LINE = 50;

/* Registration config -> social media templates */
export const USER_IMAGE_WIDTH = 180;
export const USER_IMAGE_HEIGHT = 180;
export const USER_DETAILS_WIDTH = 210;
export const TEMPLATE_ASPECT_RATIO = "16:9";
export const TEMPLATE_CONTAINER_WIDTH = 712;
export const TEMPLATE_LINE_HEIGHT_NAME = 18;
export const TEMPLATE_CONTAINER_HEIGHT = 400;
export const DEFAULT_USER_INFO_BOX_HEIGHT = 0;
export const TEMPLATE_LINE_HEIGHT_NAME_ORG = 46;
export const TEMPLATE_LINE_HEIGHT_NAME_JOB_TITLE_ORG = 74;
/* Selction Screen - Header and Body Height  */
export const SELECTION_HEADER_HEIGHT = 102;
export const SELECTION_BODY_HEIGHT = `calc(100% - ${SELECTION_HEADER_HEIGHT}px)`;

/* Exhibitor Screen - Header and Body Height  */
export const EXHIBITOR_HEADER_HEIGHT = 64;
export const EXHIBITOR_BODY_HEIGHT = `calc(100% - ${EXHIBITOR_HEADER_HEIGHT}px)`;

/* Exhibitor With Add to My Schedule Screen - Header and Body Height  */
export const ADDTOSHEDULE_HEADER_HEIGHT = 98;
export const ADDTOSHEDULE_BODY_HEIGHT = `calc(100% - ${ADDTOSHEDULE_HEADER_HEIGHT}px)`;

/* My Organization Schedule Screen - Header and Body Height  */
export const MY_ORG_SCHEDULE_HEADER_HEIGHT = 68;
export const MY_ORG_SCHEDULE_BODY_HEIGHT = `calc(100% - ${MY_ORG_SCHEDULE_HEADER_HEIGHT}px)`;

/* ContaCT Screen - Header and Body Height  */
export const CONTACT_HEADER_HEIGHT = 56;
export const CONTACT_BODY_HEIGHT = `calc(100% - ${CONTACT_HEADER_HEIGHT}px)`;

export const AGENDA_PARTICIPANT_BIO_HEIGHT = 32;
export const AGENDA_PARTICIPANT_BIO_LINES = 2;

export const REG_EMAIL_CONFIG_SUB_HEADER_HEIGHT = 120;
export const REG_EMAIL_CONFIG_FOOTER_HEIGHT = 120;

export const TICKET_CARD_DESCRIPTION_HEIGHT = 96;
export const TICKET_CARD_DESCRIPTION_LINES_3 = 3;
export const TICKET_CARD_DESCRIPTION_LINES_6 = 6;
